import { defineComponent as _defineComponent } from 'vue'
import type { Reservation } from '@/models/Reservation'
import type { ViewProperties } from '@/models/ViewProperties'

import type { PropType } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'TicketsReservations',
  props: {
  viewProperties: {
    required: true,
    type: Object as PropType<ViewProperties>
  },
},
  emits: ['delete-res'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props






// eslint-disable-next-line @typescript-eslint/no-unused-vars
const deleteRes = (res: Reservation) => {
  emit('delete-res', res)
}


const __returned__ = { props, emit, deleteRes }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})